// ─── Rýchle voľby obdobia v Prehľade ──────────────────────────────────────────
// Dátumy sú "YYYY-MM-DD" v MIESTNOM čase. Nikde sa nepoužíva toISOString():
// ten počíta v UTC, takže medzi polnocou a druhou hodinou ráno by "dnes"
// vrátil včerajší dátum.

export function toISODate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

// Posun cez setDate, nie pripočítaním 24 h — deň so zmenou letného času
// má 23 alebo 25 hodín a pripočítanie by občas preskočilo alebo zopakovalo deň.
export function shiftISODate(isoDate, dayOffset) {
  const shifted = new Date(`${isoDate}T00:00:00`);
  shifted.setDate(shifted.getDate() + dayOffset);
  return toISODate(shifted);
}

// `days` = koľko dní obdobie zahŕňa vrátane posledného; `endOffset` = o koľko
// dní pred dneškom končí. "7 dní" a "Mesiac" sú kĺzavé a končia dnešným dňom.
// Mesiac je kĺzavých 30 dní, nie kalendárny mesiac: inak by sa 1. dňa
// v mesiaci kryl s "Dnes" a oba by svietili naraz.
export const DATE_PRESETS = [
  { key: "today",     label: "Dnes",   title: "Iba dnešný deň",               days: 1,  endOffset: 0 },
  { key: "yesterday", label: "Včera",  title: "Iba včerajší deň",             days: 1,  endOffset: 1 },
  { key: "week",      label: "7 dní",  title: "Dnes a 6 predchádzajúcich dní", days: 7,  endOffset: 0 },
  { key: "month",     label: "Mesiac", title: "Posledných 30 dní vrátane dneška", days: 30, endOffset: 0 },
];

export function getPresetRange(key, now = new Date()) {
  const preset = DATE_PRESETS.find((p) => p.key === key);
  if (!preset) return null;
  const endDate = shiftISODate(toISODate(now), -preset.endOffset);
  return { startDate: shiftISODate(endDate, -(preset.days - 1)), endDate };
}

// Voľba sa neukladá do stavu, odvodzuje sa z rozsahu: po posune šípkou alebo
// ručnom výbere dátumov sa sama odznačí a pri zhodnom rozsahu sama rozsvieti.
export function getActivePresetKey(startDate, endDate, now = new Date()) {
  const match = DATE_PRESETS.find((p) => {
    const range = getPresetRange(p.key, now);
    return range.startDate === startDate && range.endDate === endDate;
  });
  return match ? match.key : null;
}
